// @flow
import React, { Component } from 'react'
import { Icon } from '@lanetix/unum'

type PasswordStrengthTooltipProps = {
  errors: Array<number>,
  empty: boolean,
  strong: boolean
}

export const PASSWORD_LENGTH_ERROR_CODE = 0
export const PASSWORD_REPEATED_THREE_CHARS_CODE = 2

const getCircle = (errors: any, id: any, isEmpty: any, strong: any) =>
  isEmpty || errors.includes(id)
    ? 'circle white'
    : 'circle green'

const errorMap = new Map([
  [PASSWORD_LENGTH_ERROR_CODE, 'be at least 8 characters'],
  [PASSWORD_REPEATED_THREE_CHARS_CODE, 'not contain the same three repeated characters'],
  [3, 'at least one lowercase letter'],
  [4, 'at least one uppercase letter'],
  [5, 'at least one number'],
  [6, 'at least one symbol (e.g. !@#$%^&*)']
])

const variableReq = Array.from(errorMap)
  .slice(2) // We handle the password length and repeated errors independently
  .map(([id]) => id)
// $FlowFixMe
export class PasswordStrengthTooltip extends Component {
  shouldComponentUpdate (nextProps: PasswordStrengthTooltipProps): any {
    const {
      errors: currErrors,
      empty: currEmpty,
      strong: currIsStrong
    } = this.props
    const {
      errors: nextErrors,
      empty: nextEmpty,
      strong: nextIsStrong
    } = nextProps

    // Re-render if strong is different or if errors changed
    return !(currIsStrong === nextIsStrong &&
      currEmpty === nextEmpty &&
      currErrors.length === nextErrors.length &&
      currErrors.every((e, i) => e === nextErrors[i]))
  }

  render (): any {
    const { errors, empty, strong } = this.props

    return (
      <div className='pw-reset-password__check'>
        <label>Password Must:</label>
        <div className='check' key={`password-req-${PASSWORD_LENGTH_ERROR_CODE}`}>
          <div className={`${getCircle(errors, PASSWORD_LENGTH_ERROR_CODE, empty, strong)}`} />
          <div>{errorMap.get(PASSWORD_LENGTH_ERROR_CODE)}</div>
        </div>
        <div className='check' key={`password-req-${PASSWORD_REPEATED_THREE_CHARS_CODE}`}>
          <div className={`${getCircle(errors, PASSWORD_REPEATED_THREE_CHARS_CODE, empty, strong)}`} />
          <div>{errorMap.get(PASSWORD_REPEATED_THREE_CHARS_CODE)}</div>
        </div>
        <br />
        <label>It must meet <strong>3</strong> of the following requirements:</label>
        {variableReq.map(id =>
          <div className='check' key={`password-req-${id}`}>
            <div className={`${getCircle(errors, id, empty, strong)}`} />
            <div>{errorMap.get(id)}</div>
          </div>
        )}
        <br />
        <label>Strength</label>
        <div>{!empty && strong
          ? <span className='pw-reset-password__check__strong'>
            <Icon title='strong' icon='check' />&nbsp;<span className='text'>Strong</span>
          </span>
          : <span className='pw-reset-password__check__weak'>Weak</span>}
        </div>
      </div>
    )
  }
}
